// PostNotes.js

import React, { useEffect, useState } from "react";

import {
  Modal,
  Form,
  Input,
  Select,
  Upload,
  Button,
  Row,
  Col,
  Typography,
  message
} from "antd";

import {
  UploadOutlined,
  FileAddOutlined
} from "@ant-design/icons";

import api from "../../api/api";


const { TextArea } = Input;
const { Title } = Typography;


const PostNotes = ({ open, onClose }) => {


const [gradeClasses,setGradeClasses] = useState([]);

const [loading,setLoading] = useState(false);

const [form] = Form.useForm();



/* ---------------- CLOSE MODAL ---------------- */

const handleClose = () => {

form.resetFields();

onClose();

};





/* ---------------- FETCH GRADE CLASSES ---------------- */

useEffect(()=>{


const fetchGradeClasses = async()=>{


try{


const res = await api.get(
"/api/users/grade-classes/"
);


setGradeClasses(
res.data.results || res.data
);



}
catch(error){


console.log(
error.response?.data
);


message.error(
"Failed to load grade classes"
);


}


};



if(open){

fetchGradeClasses();

}


},[open]);







/* ---------------- SUBMIT NOTE ---------------- */


const submitNote = async(values)=>{


const formData = new FormData();



formData.append(
"title",
values.title
);



formData.append(
"description",
values.description || ""
);



formData.append(
"grade_class",
values.grade_class
);



formData.append(
"file_type",
values.file_type
);




if(
values.file &&
values.file.length > 0
){

formData.append(
"file",
values.file[0].originFileObj
);

}





try{


setLoading(true);



await api.post(

"/notes/",

formData,

{

headers:{

Authorization:
`Bearer ${localStorage.getItem("token")}`,

"Content-Type":
"multipart/form-data"

}

}

);



message.success(
"Learning note posted successfully!"
);



form.resetFields();


onClose();



}
catch(error){


console.log(
"POST NOTE ERROR:",
error.response?.data
);



message.error(

error.response?.data
?
JSON.stringify(error.response.data)
:
"Failed to post note"

);



}
finally{


setLoading(false);


}



};







return (


<Modal


open={open}


/* FIXED CLOSE FUNCTION */

onCancel={handleClose}



footer={null}


width={850}


maskClosable={false}


keyboard={true}


closable={true}


destroyOnClose


className="post-note-modal"



>





<div
style={{
padding:"10px 5px"
}}
>





<Title

level={3}

style={{

color:"#800000",

textAlign:"center"

}}

>


<FileAddOutlined/>


&nbsp;


Post New Learning Note



</Title>







<Form


form={form}


layout="vertical"


onFinish={submitNote}



>




<Row gutter={[20,10]}>


{/* TITLE */}

<Col xs={24} md={12}>


<Form.Item

name="title"

label="Note Title"

rules={[
{
required:true,
message:"Title is required"
}
]}

>


<Input

placeholder="Enter note title"

/>


</Form.Item>


</Col>








{/* CLASS */}


<Col xs={24} md={12}>


<Form.Item

name="grade_class"

label="Grade Class"

rules={[
{
required:true,
message:"Select grade class"
}
]}

>


<Select

placeholder="Select class"

showSearch

optionFilterProp="children"

>


{

gradeClasses.map(gc=>(


<Select.Option

key={gc.id}

value={gc.id}

>


{gc.name}


</Select.Option>



))


}



</Select>



</Form.Item>



</Col>









{/* DESCRIPTION */}


<Col xs={24}>


<Form.Item

name="description"

label="Description"

>


<TextArea

rows={4}

placeholder="Write note description"

/>


</Form.Item>


</Col>









{/* FILE TYPE */}


<Col xs={24} md={12}>


<Form.Item

name="file_type"

label="File Type"

initialValue="pdf"

>


<Select>


<Select.Option value="pdf">

PDF

</Select.Option>



<Select.Option value="docx">

Word Document

</Select.Option>



<Select.Option value="pptx">

PowerPoint

</Select.Option>



<Select.Option value="other">

Other

</Select.Option>



</Select>


</Form.Item>


</Col>









{/* FILE UPLOAD */}


<Col xs={24} md={12}>


<Form.Item

name="file"

label="Upload File"

valuePropName="fileList"

getValueFromEvent={(e)=>
e.fileList
}

rules={[
{
required:true,
message:"Please upload file"
}
]}

>


<Upload


beforeUpload={()=>false}


accept=".pdf,.doc,.docx,.ppt,.pptx"


maxCount={1}



>



<Button

icon={<UploadOutlined/>}

block

>


Choose File


</Button>



</Upload>



</Form.Item>



</Col>









{/* SUBMIT BUTTON */}


<Col xs={24}>


<Button


htmlType="submit"


type="primary"


loading={loading}


block


style={{

height:45,

background:"#800000",

fontWeight:"bold"

}}



>


{

loading

?

"Publishing Note..."

:

"Publish Note"

}



</Button>


</Col>





</Row>





</Form>







</div>





</Modal>



);


};



export default PostNotes;


// // PostNotes.js
// import React, { useState, useEffect } from "react";
// import {
//   Box,
//   Button,
//   TextField,
//   MenuItem,
//   Typography,
//   Paper,
//   CircularProgress,
//   Grid
// } from "@mui/material";
// import { useForm, Controller } from "react-hook-form";
// import { toast } from "react-toastify";
// import api from "../../api/api";

// const PostNotes = () => {
//   const [gradeClasses, setGradeClasses] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const { handleSubmit, control, reset } = useForm();

//   useEffect(() => {
//     // Fetch grade classes for the dropdown
//     const fetchGradeClasses = async () => {
//       try {
//         const res = await api.get("/api/users/grade-classes/");
//         setGradeClasses(res.data);
//       } catch (error) {
//         console.error(error);
//         toast.error("Failed to load grade classes");
//       }
//     };
//     fetchGradeClasses();
//   }, []);

//   const onSubmit = async (data) => {
//     const formData = new FormData();
//     formData.append("title", data.title);
//     formData.append("description", data.description);
//     formData.append("grade_class", data.grade_class);
//     formData.append("file", data.file[0]);
//     formData.append("file_type", data.file_type);

//     try {
//       setLoading(true);
//       await api.post("/notes/", formData, {
//         headers: { "Content-Type": "multipart/form-data" },
//       });
//       toast.success("Note posted successfully!");
//       reset();
//     } catch (error) {
//       console.error(error);
//       toast.error("Failed to post note");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Box p={3}>
//       <Typography variant="h5" mb={3}>
//         Post a New Note
//       </Typography>
//       <Paper elevation={3} sx={{ p: 3 }}>
//         <form onSubmit={handleSubmit(onSubmit)}>
//           <Grid container spacing={2}>
//             <Grid item xs={12} md={6}>
//               <Controller
//                 name="title"
//                 control={control}
//                 defaultValue=""
//                 rules={{ required: "Title is required" }}
//                 render={({ field, fieldState }) => (
//                   <TextField
//                     {...field}
//                     label="Title"
//                     fullWidth
//                     error={!!fieldState.error}
//                     helperText={fieldState.error?.message}
//                   />
//                 )}
//               />
//             </Grid>

//             <Grid item xs={12} md={6}>
//               <Controller
//                 name="grade_class"
//                 control={control}
//                 defaultValue=""
//                 rules={{ required: "Grade Class is required" }}
//                 render={({ field, fieldState }) => (
//                   <TextField
//                     {...field}
//                     select
//                     label="Grade Class"
//                     fullWidth
//                     error={!!fieldState.error}
//                     helperText={fieldState.error?.message}
//                   >
//                     {gradeClasses.map((gc) => (
//                       <MenuItem key={gc.id} value={gc.id}>
//                         {gc.name}
//                       </MenuItem>
//                     ))}
//                   </TextField>
//                 )}
//               />
//             </Grid>

//             <Grid item xs={12}>
//               <Controller
//                 name="description"
//                 control={control}
//                 defaultValue=""
//                 render={({ field }) => (
//                   <TextField
//                     {...field}
//                     label="Description"
//                     fullWidth
//                     multiline
//                     rows={3}
//                   />
//                 )}
//               />
//             </Grid>

//             <Grid item xs={12} md={6}>
//               <Controller
//                 name="file_type"
//                 control={control}
//                 defaultValue="pdf"
//                 render={({ field }) => (
//                   <TextField {...field} select label="File Type" fullWidth>
//                     <MenuItem value="pdf">PDF</MenuItem>
//                     <MenuItem value="docx">Word Document</MenuItem>
//                     <MenuItem value="pptx">PowerPoint</MenuItem>
//                     <MenuItem value="other">Other</MenuItem>
//                   </TextField>
//                 )}
//               />
//             </Grid>

//             <Grid item xs={12} md={6}>
//               <Controller
//                 name="file"
//                 control={control}
//                 rules={{ required: "File is required" }}
//                 render={({ field, fieldState }) => (
//                   <>
//                     <Button
//                       variant="contained"
//                       component="label"
//                       fullWidth
//                     >
//                       Upload File
//                       <input
//                         type="file"
//                         hidden
//                         accept=".pdf,.doc,.docx,.ppt,.pptx"
//                         onChange={(e) => field.onChange(e.target.files)}
//                       />
//                     </Button>
//                     {fieldState.error && (
//                       <Typography color="error" variant="body2">
//                         {fieldState.error.message}
//                       </Typography>
//                     )}
//                   </>
//                 )}
//               />
//             </Grid>

//             <Grid item xs={12}>
//               <Button
//                 type="submit"
//                 variant="contained"
//                 color="primary"
//                 disabled={loading}
//                 startIcon={loading && <CircularProgress size={20} />}
//               >
//                 {loading ? "Posting..." : "Post Note"}
//               </Button>
//             </Grid>
//           </Grid>
//         </form>
//       </Paper>
//     </Box>
//   );
// };

// export default PostNotes;
